import React from 'react';

export const FloorPlanConsultaSuccessModal = ({
  isOpen,
  consultaNumero,
  onClose,
  onBackToSite,
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" data-testid="floorplan-editor-consulta-modal-overlay">
      <div className="bg-white rounded-2xl p-8 w-full max-w-md mx-4 text-center" data-testid="floorplan-editor-consulta-modal">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-testid="floorplan-editor-consulta-success-icon">
          <span className="text-4xl">✅</span>
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2" data-testid="floorplan-editor-consulta-success-title">Consulta Enviada!</h2>
        <p className="text-gray-600 mb-6" data-testid="floorplan-editor-consulta-success-message">
          Sua solicitação de orçamento foi enviada com sucesso. Um email de confirmação foi enviado para você.
        </p>
        <div className="bg-green-50 border-2 border-green-200 rounded-xl p-4 mb-6" data-testid="floorplan-editor-consulta-number-box">
          <p className="text-sm text-green-700 mb-1">Número da Consulta</p>
          <p className="text-2xl font-bold text-green-800 tracking-wider" data-testid="floorplan-editor-consulta-number">{consultaNumero}</p>
        </div>
        <p className="text-sm text-gray-500 mb-6" data-testid="floorplan-editor-consulta-hint">
          Guarde este número para acompanhar sua consulta. Nossa equipe entrará em contato em breve!
        </p>
        <div className="flex gap-3">
          <button onClick={onClose} className="flex-1 px-4 py-3 border rounded-lg hover:bg-gray-50" data-testid="floorplan-editor-consulta-close-button">
            Fechar
          </button>
          <button onClick={onBackToSite} className="flex-1 px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700" data-testid="floorplan-editor-consulta-back-site-button">
            Voltar ao Site
          </button>
        </div>
      </div>
    </div>
  );
};
